export const featuerList =[
    {
        heading1: "sustainable",
        heading2: "living + development",
        description: "Focused around, energy & resources, infrastructure & communities, inclusive governance, and new frontiers"
    },
    {
        heading1: "clean + healthy",
        heading2: "consumption",
        description: "Focused around, agriculture & organic foods, water & air, and inclusive healthcare systems"
    },
]